/**
 * Things that happen for both marketing and portal
 */
import './polyfill';
import './vue';
import './notification';
import './global-navigation';
import './expandableMenus';
import './recaptcha';
import loginModal from './loginModal';
import password from './password';
import './useragent';

loginModal();
password();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/index.js